module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h2', {
    staticClass: "u"
  }, [_vm._v("\n    Дома\n    "), (_vm.total) ? _c('span', [_vm._v("(" + _vm._s(_vm.total) + ")")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'building-add'
      }
    }
  }, [_vm._v("+ Добавить дом")])], 1), _vm._v(" "), _c('resource-list', {
    attrs: {
      "url": "/buildings",
      "current-sort": "number",
      "init-sort-type": "asc",
      "resource-name": "buildings",
      "show-per-page": false,
      "action-routes": _vm.actionRoutes,
      "fields": _vm.fields,
      "filters": _vm.filters
    },
    on: {
      "total": _vm.updateTotal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18200594","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/building/Buildings.vue
// module id = 587
// module chunks = 0